import { z } from 'zod';
import { VoucherType } from '@prisma/client';

// Cash vouchers are generated when a BDM2 outcome is imported, never CSV-uploaded; only the
// two Galaxus denominations can be added to the pool this way. A whole batch is always one
// type: the shop chooses a denomination once in the UI, for the whole file.
export const uploadableVoucherType = z.enum([
  VoucherType.TenEuros,
  VoucherType.FiveEuros,
]);

export const batchOfNewVouchersReqDto = z.object({
  type: uploadableVoucherType,
  codes: z.array(z.string().max(16)),
});
export type BatchOfNewVouchersReqDto = z.infer<typeof batchOfNewVouchersReqDto>;
